import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';

import { lastOpenProjectAtom } from '#state/atoms/last-open-project-atom.js';

// This route is simply a redirect from `/projects` to `/orgs/$orgName/projects`.
export const Route = createFileRoute('/_authorization-gate/projects')({
	beforeLoad: async ({ context }) => {
		// Find a good org to redirect to. If there was a `lastOpenProject.orgName`, we prefer that one. Otherwise fall back
		// to the first organization from the user's memberships array.

		const store = getDefaultStore();
		const lastOpenProject = store.get(lastOpenProjectAtom);
		const currentUser = await context.queryClient.ensureQueryData(context.trpc.user.getCurrent.queryOptions());

		// Check if the user has access to the org in the atom
		if (lastOpenProject.orgName !== null && lastOpenProject.orgName !== '') {
			const hasAccessToOrg =
				currentUser.auth.isStaff || currentUser.memberships.some((m) => m.groupUsername === lastOpenProject.orgName);
			if (hasAccessToOrg) {
				throw redirect({ to: '/orgs/$orgName/projects', params: { orgName: lastOpenProject.orgName } });
			}
			// If no access to the org in the atom, fall back to the code below
		}

		// Try to redirect to the first organization from the user's memberships
		const firstMembership = currentUser.memberships[0];
		if (firstMembership) {
			throw redirect({ to: '/orgs/$orgName/projects', params: { orgName: firstMembership.groupUsername } });
		}

		throw new Error(
			'You are not a member of any organizations. Please contact your administrator to be added to an organization.',
		);
	},
});
